import * as React from 'react';

const SvgAlbumFill = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M3 18V3h16v2H5v13H3Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 7h15v8.164l-4.026-4.732-4.057 5.07-2-2L7 19.579V7Zm6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8.432 21H22v-2.763l-3.973-4.67-3.944 4.93-2-2L8.433 21Z", fill: "currentColor" })));

export { SvgAlbumFill as default };
